import dental1 from "./default/dental1.svg";
import dental2 from "./default/dental2.svg";
import dental3 from "./default/dental3.svg";
import dental4 from "./default/dental4.svg";
import dental5 from "./default/dental5.svg";
import dental6 from "./default/dental6.svg";
import dental7 from "./default/dental7.svg";
import dental8 from "./default/dental8.svg";
import dental9 from "./default/dental9.svg";
import dental10 from "./default/dental10.svg";
import dental11 from "./default/dental11.svg";
import dental12 from "./default/dental12.svg";
import dental13 from "./default/dental13.svg";
import dental14 from "./default/dental14.svg";
import dental15 from "./default/dental15.svg";
import dental16 from "./default/dental16.svg";

import dental1hover from "./hover/dental1.svg";
import dental2hover from "./hover/dental2.svg";
import dental3hover from "./hover/dental3.svg";
import dental4hover from "./hover/dental4.svg";
import dental5hover from "./hover/dental5.svg";
import dental6hover from "./hover/dental6.svg";
import dental7hover from "./hover/dental7.svg";
import dental8hover from "./hover/dental8.svg";
import dental9hover from "./hover/dental9.svg";
import dental10hover from "./hover/dental10.svg";
import dental11hover from "./hover/dental11.svg";
import dental12hover from "./hover/dental12.svg";
import dental13hover from "./hover/dental13.svg";
import dental14hover from "./hover/dental14.svg";
import dental15hover from "./hover/dental15.svg";
import dental16hover from "./hover/dental16.svg";

import dental1active from "./active/dental1.svg";
import dental2active from "./active/dental2.svg";
import dental3active from "./active/dental3.svg";
import dental4active from "./active/dental4.svg";
import dental5active from "./active/dental5.svg";
import dental6active from "./active/dental6.svg";
import dental7active from "./active/dental7.svg";
import dental8active from "./active/dental8.svg";
import dental9active from "./active/dental9.svg";
import dental10active from "./active/dental10.svg";
import dental11active from "./active/dental11.svg";
import dental12active from "./active/dental12.svg";
import dental13active from "./active/dental13.svg";
import dental14active from "./active/dental14.svg";
import dental15active from "./active/dental15.svg";
import dental16active from "./active/dental16.svg";

export default [
  {
    img: dental1,
    imgHover: dental5hover,
    imgActive: dental1active,
    top: "136.5px",
    left: "8.5px",
    class: "dental"
  },
  {
    img: dental2,
    imgHover: dental1hover,
    imgActive: dental2active,
    top: "109.4px",
    left: "7.5px",
    class: "dental"
  },
  {
    img: dental3,
    imgHover: dental3hover,
    imgActive: dental3active,
    top: "86.5px",
    left: "11.5px",
    class: "dental"
  },
  {
    img: dental4,
    imgHover: dental9hover,
    imgActive: dental4active,
    top: "66.5px",
    left: "18.5px",
    class: "dental"
  },
  {
    img: dental5,
    imgHover: dental10hover,
    imgActive: dental5active,
    top: "47.5px",
    left: "30.5px",
    class: "dental"
  },
  {
    img: dental15,
    imgHover: dental15hover,
    imgActive: dental6active,
    top: "33px",
    left: "42px",
    class: "dental"
  },
  {
    img: dental6,
    imgHover: dental13hover,
    imgActive: dental7active,
    top: "14.5px",
    left: "53.5px",
    class: "dental"
  },
  {
    img: dental7,
    imgHover: dental6hover,
    imgActive: dental8active,
    top: "8.5px",
    left: "73.5px",
    class: "dental"
  },
  {
    img: dental8,
    imgHover: dental7hover,
    imgActive: dental9active,
    top: "8.5px",
    left: "100.5px",
    class: "dental"
  },
  {
    img: dental9,
    imgHover: dental12hover,
    imgActive: dental10active,
    top: "15.5px",
    left: "123.5px",
    class: "dental"
  },
  {
    img: dental16,
    imgHover: dental14hover,
    imgActive: dental11active,
    top: "33px",
    left: "137px",
    class: "dental"
  },
  {
    img: dental10,
    imgHover: dental11hover,
    imgActive: dental12active,
    top: "47.5px",
    left: "145.5px",
    class: "dental"
  },
  {
    img: dental11,
    imgHover: dental8hover,
    imgActive: dental13active,
    top: "66.5px",
    left: "155.5px",
    class: "dental"
  },
  {
    img: dental12,
    imgHover: dental2hover,
    imgActive: dental14active,
    top: "86.5px",
    left: "161.5px",
    class: "dental"
  },
  {
    img: dental13,
    imgHover: dental16hover,
    imgActive: dental15active,
    top: "109.5px",
    left: "166.5px",
    class: "dental"
  },
  {
    img: dental14,
    imgHover: dental4hover,
    imgActive: dental16active,
    top: "136.5px",
    left: "164.5px",
    class: "dental"
  }
];
